<template>
  <v-dialog 
    v-model="dialog"
    fullscreen 
    full-width
    transition="none"
  >
    <v-container 
      bg 
      fluid 
      fill-height 
      class="browser"
    >
      <v-layout 
        justify-center 
        align-center
      >
        <v-card flat>
          <v-card-text>
            <h2 class="important-note">Important Note</h2>
            <div class="mt-3 mb-3 white">
              <p>
                You are using the browser from the QR code scanner. It may not work with our app.
              </p>
              <p>
                Please copy the following URL and paste it in either 
                <span class="browser-name">Safari</span> or 
                <span class="browser-name">Chrome</span>.
              </p>
              <p>
                <v-btn
                  v-clipboard:copy="fullUrl"
                  @click="onCopy"
                  :color="theme.btn_color_secondary"
                  dark
                >Copy</v-btn>
                <span
                  v-if="msg"
                  :class="msgColor"
                >{{ msg }}</span>
              </p>
              <p class="blue-grey--text">
                <input
                  type="text"
                  readonly
                  style="width:100%;"
                  v-model="fullUrl"
                >
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'browser',
  data () {
    return {
      dialog: true,
      msg: '',
      msgColor: ''
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'tbdata', 'siteUrl'
    ]),
    fullUrl () {
      return this.tbdata ? this.siteUrl + '/' + this.tbdata.qr_code : this.siteUrl
    }
  },
  methods: {
    onCopy () {
      this.msg = 'URL was copied successfully'
      this.msgColor = 'green--text'
    },
    onError () {
      this.msg = 'Unable to copy'
      this.msgColor = 'red--text'
    }
  },
}
</script>

<style scoped>
.browser {
  background-color: white;
}
.important-note {
  text-transform: uppercase;
  text-align: center;
}
.cbox {
  margin: 0;
}
.hidden-input-box {
  z-index: -9999;
}
.browser-name {
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// src/components/Browser.vue